import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { IntranetoldService } from 'src/app/api/intranetold.service';
import { MongoService } from 'src/app/api/mongo.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-crear-editar-meta',
  templateUrl: './crear-editar-meta.component.html',
  styleUrls: ['./crear-editar-meta.component.css']
})
export class CrearEditarMetaComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    private _apiMongo: MongoService,
    private _api:IntranetoldService
    ) { }
  data:any;
  usuarios:any;
  cargando:boolean = false;

  async ngOnInit(): Promise<void> {

    
    this.cargando = true;
    var res:any = await this._api.getAllLogin();
    this.cargando = false;
    if(res.estado)
    {
      this.usuarios = [...res.objeto];
      
    }

  }
  async guardar(){

    

    if (this.data._id) {
      var datos:any = await this._apiMongo.actualizarMeta(this.data);
    }else
    {
      var datos:any = await this._apiMongo.crearMetaVendedor(this.data);
    }

    if (datos.estado) {
      Swal.fire({
        title: '¡Éxito!',
        text: datos.mensaje,
        icon: 'success',
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false
      });
      window.location.reload();
    }
      else
    {
      Swal.fire({
        title: '¡Error!',
        text: datos.mensaje,
        icon: 'error',
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false
      });      
    }
    

    
    var modelo = {
      SlpCode:this.data.SlpCode,
      CONCEPTO:"META",
      NOMBRE:this.data.NOMBRE,
      MES:this.data.MES,
      ANIO:this.data.ANIO,
      VALOR:this.data.VALOR
    }


  this.activeModal.dismiss(datos);

}

  cerrar() {
    this.activeModal.close();
  }

  aplicaNombre(){
    this.usuarios.forEach(element => {
      if (element.VENDEDOR == this.data.SlpCode) {
        this.data.NOMBRE = element.NOMBRE;
      }
    });
  }


}
